import moment from "moment";
import ReactCountryFlag from "react-country-flag";
import { getLanguageFromDictionary } from "../core/dictionary/language-options";
import { getMatchTypeFromDictionary } from "../core/dictionary/match-type";
import { getCountryOfImportsFromDictionary } from "../core/dictionary/country-of-imports";
const countryMap = getCountryOfImportsFromDictionary.countryOfImports;

//to get current date
export const getCurrentDate = () => moment(new Date()).format("YYYY-MM-DD");

export const sanitizeTooltipId = (value) => `${value ?? ""}`.replace(/[^a-zA-Z0-9_-]/g, "");

//to get ISO code of given country name in given list or array
export const getIsoCode = (arr = [], countryName) => {
  const data = arr?.length > 0 && arr.filter((item) => item.value === countryName);
  return data[0]?.labelvalue;
};

//to get language options
export const getLanguageOptions = () => {
  const arr = getLanguageFromDictionary.language;

  return (
    arr?.length > 0 &&
    arr.map((item) => ({
      value: item.id,
      label: item.name,
    }))
  );
};

//to get match type options
export const getMatchTypeOptions = () => {
  const arr = getMatchTypeFromDictionary.matchType;

  return (
    arr?.length > 0 &&
    arr.map((item) => ({
      value: item.name,
      label: item.id,
    }))
  );
};

// to get countryCode to show flags
export const getCountryCode = (iso) => {
  switch (iso) {
    case "XC":
      return "EA";
    case "XL":
      return "EA";
    case "XI":
      return "GB-NIR";
    default:
      return iso;
  }
};

export const getMinDate = (iso) => {
  switch (iso) {
    case "US":
      return "2022-04-04";
    case "MX":
      return "2022-07-01";
    default:
      return "2022-01-01";
  }
};

//to create options for countries select
export const getSelectOptions = (arr = []) => {
  if (!arr || !Array.isArray(arr)) return [];
  const newArray = arr.map((item) => ({
    value: item.name,
    labelvalue: item.country_iso_code,
    label: (
      <div className="tw-flex tw-items-center tw-gap-2">
        <ReactCountryFlag className="tw-size-6" countryCode={getCountryCode(item?.country_iso_code)} svg />
        <span className="tw-text-label-md">{`${item.name} - ${item?.country_iso_code}`}</span>
      </div>
    ),
  }));
  return newArray;
};

//to get different min-dates country wise
export const getMinDateCountryWise = (data) => {
  let dateObj = {};
  for (const country_key in data) {
    dateObj[country_key] = data[country_key]["minDate"];
  }
  return dateObj;
};

export const ArrayToString = (inputValue) => {
  if (!!inputValue && inputValue !== "") {
    if (Array.isArray(inputValue)) {
      if (inputValue.length > 1) {
        const flatarray = inputValue.flat();
        for (let i = 0; i < flatarray.length; i++) {
          flatarray[i] = countryMap.find((item) => item.id === flatarray[i])?.name;
        }
        const values = flatarray.join(" , ");
        return values;
      } else {
        return countryMap.find((item) => item.id === inputValue[0])?.name;
      }
    } else {
      return countryMap.find((item) => item.id === inputValue)?.name;
    }
  } else {
    return inputValue;
  }
};
